@if (store.authInfo()?.token !== null) {
  <router-outlet />
} @else {
  <app-login></app-login>
}

